import React from 'react';

interface Props {
  children: React.ReactNode;
  /** Título do formulário, dentro do cartão. Telas de resultado trazem o próprio título. */
  title?: string;
  subtitle?: React.ReactNode;
  /** Linhas extras no rodapé (ex.: versão da aplicação). */
  footerExtra?: React.ReactNode;
}

const FALLBACK_CREST =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='52' height='52' viewBox='0 0 24 24' fill='none' stroke='%2393c5fd' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'/%3E%3Cpolyline points='9 22 9 12 15 12 15 22'/%3E%3C/svg%3E";

/**
 * Moldura das telas públicas (login, cadastro, recuperação de senha).
 *
 * A faixa de marca é azul-marinho nos dois modos de cor de propósito: é
 * identidade visual e não deve inverter. O formulário abaixo dela usa tokens
 * e acompanha claro/escuro.
 */
const AuthLayout: React.FC<Props> = ({ children, title, subtitle, footerExtra }) => (
  <div className="flex min-h-screen flex-col bg-canvas text-fg">
    <header className="flex flex-col items-center bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 px-6 pb-8 pt-12 text-center">
      <div className="mb-6 flex h-24 w-24 items-center justify-center overflow-hidden rounded-full border-2 border-blue-400/40 bg-white/5 shadow-2xl">
        <img
          src="favicon.ico"
          alt="Brasão de Sinop"
          className="h-20 w-20 object-contain drop-shadow-lg"
          onError={e => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = FALLBACK_CREST;
          }}
        />
      </div>
      <p className="mb-3 text-sm font-semibold uppercase tracking-widest text-blue-300">
        Prefeitura Municipal de Sinop — MT
      </p>
      <h1 className="mb-2 text-4xl font-bold leading-tight text-white sm:text-5xl">SIGEM</h1>
      <p className="text-base font-medium text-blue-300">Sistema de Gestão de Emendas Municipais</p>
    </header>

    <main className="flex flex-1 items-start justify-center px-4 py-8">
      <div className={`w-full max-w-sm rounded-panel border border-line bg-surface p-6 shadow-sm`}>
        {title && (
          <div className="mb-5 text-center">
            <h2 className="text-xl font-bold text-fg">{title}</h2>
            {subtitle && <p className="mt-1 text-sm text-fg-muted">{subtitle}</p>}
          </div>
        )}
        {children}
      </div>
    </main>

    <footer className="space-y-1 border-t border-line py-5 text-center text-xs text-fg-subtle">
      <div>&copy; {new Date().getFullYear()} SIGEM &mdash; Prefeitura Municipal de Sinop &mdash; MT &middot; Todos os direitos reservados</div>
      <div>Desenvolvido em Parceria com a Diretoria de Softwares e Suporte a TIC.</div>
      {footerExtra}
    </footer>
  </div>
);

export default AuthLayout;
